export default "__VITE_PUBLIC_ASSET__5f0ced57__"